
import { Component, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { NgForm } from '@angular/forms';
import { MessageService } from 'primeng/api';
import { Messages } from '@app/constants/constant';
import {  TechnologyAddEditService } from './technology-add.service';

@Component({
  selector: 'app-technology-modal',
  templateUrl: './technology-modal.component.html',
  styleUrls: ['./technology-modal.component.css'],
  providers : [TechnologyAddEditService] 
})
export class TechnologyModalComponent implements OnInit {

  showCrossIcon = true;
  displayDialog : boolean = false;

  editFlag :boolean;
  @Input() display: boolean;
  @Output() displayFunction = new EventEmitter<boolean>();
  @Output() techData = new EventEmitter<Object>();
  @Input() searchedTechnology :any;
  @Input() isEditable : boolean;



  @ViewChild('createTechnologyForm', { static: false }) public createTechnologyForm: NgForm;
  techCreation:any = {
    id : '',
    name : '',
    isActive : true,
    hasTemplate: false,
    addAllowed: true
  };

  showCloseIcon(){
    this.showCrossIcon=false
  };

  constructor(
    private _toastService: MessageService,
    private _apiService : TechnologyAddEditService
  ) { }

  ngOnInit() {
    this.editFlag = this.display && this.isEditable && this.searchedTechnology  ? true : false;
    if (this.editFlag)
    {
      this.updateForm();
    }
  }

  showDialog(bool: boolean) {
    this.displayFunction.emit(bool);
  }

  createTechnology() {

    if(this.editFlag){
      this._apiService.editTechnology(this.techCreation).subscribe(res =>
        {
        this._toastService.add({ severity: 'success', summary:this.editFlag ? Messages.technologyEdited: Messages.technologyCreatedSuccess, detail: '' });
          this.techData.emit(this.techCreation);
          this.showDialog(false);
          this.createTechnologyForm.reset();
      }, (err) => { 
        this._toastService.add({ severity: 'error', summary:this.editFlag ? Messages.technologyEditedError : Messages.technologyCreatedError, detail: err.error });
        this.showDialog(false);
        this.createTechnologyForm.reset();
        })
    }
    else
    {
          this._apiService.addTechnology(this.techCreation).subscribe(res => {
            this.techData.emit(this.techCreation);
            this.showDialog(false);
            this.createTechnologyForm.reset();
            this._toastService.add({ severity: 'success', summary: Messages.technologyCreatedSuccess, detail: '' });
          }, (err) => { 
            this._toastService.add({ severity: 'error', summary: Messages.technologyCreatedError, detail: err.error });
            this.showDialog(false);
            this.createTechnologyForm.reset();
          });
    }
}

  updateForm()
  {
    if (this.searchedTechnology)
    {
      this.techCreation.name = this.searchedTechnology.selectedTechnology.name;
      this.techCreation.id = this.searchedTechnology.selectedTechnology.id;
      this.techCreation.isActive = this.searchedTechnology.selectedTechnology.isActive;
      this.techCreation.addAllowed = this.searchedTechnology.selectedTechnology.addAllowed;
      this.techCreation.hasTemplate = this.searchedTechnology.selectedTechnology.hasTemplate;
    }
  }

  showHideConfirmBox(bool : boolean)
  {
      this.displayDialog = false;
      if (bool || this.isEditable)
      {
        this.createTechnology();
      }
  }

  openConfirmBox()
  {
    if(this.isEditable)
    {
      this.createTechnology();
    }
    else{
      this.displayDialog = true;
    }
  }


  

}
